export default "__VITE_ASSET__BM_7AXKa__"